import { __require as requireOutside } from "./outside.js";
var ltr_1;
var hasRequiredLtr;
function requireLtr() {
  if (hasRequiredLtr) return ltr_1;
  hasRequiredLtr = 1;
  const outside = requireOutside();
  const ltr = (version, range, options) => outside(version, range, "<", options);
  ltr_1 = ltr;
  return ltr_1;
}
export {
  requireLtr as __require
};
//# sourceMappingURL=ltr.js.map
